import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"left":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
var attrs = ref.attrs;
return [_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c(VBtn,_vm._g(_vm._b({attrs:{"color":"red","disabled":!_vm.canBeClosed,"icon":"","loading":_vm.isLoading,"small":""}},'v-btn',attrs,false),Object.assign({}, tooltip, menu)),[_c(VIcon,{attrs:{"small":""}},[_vm._v(" mdi-close-circle-outline ")])],1)]}}],null,true)},[_vm._v(" Close Quick Interview ")])]}}])},[_c(VCard,[_c(VCardText,[_vm._v(" Are you sure you want to"),_c('br'),_vm._v(" close this Quick Interview? ")]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"red","dark":"","depressed":""},on:{"click":function (_) { return _vm.closeInterview(); }}},[_vm._v(" Confirm ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }